import { AxiosInstance } from 'axios';
import {
  IFetchTopicsParams,
  TFetchCategoriesResponse,
  TFetchTopicsResponse,
} from '@sv-support-sdk/shared-types/src/api/faq';

export default (api: AxiosInstance) => ({
  getCategories: (): Promise<TFetchCategoriesResponse> =>
    api.get('admin/faq/category', { params: { page: 1, per_page: 1000 } }),
  getTopics: (params: IFetchTopicsParams): Promise<TFetchTopicsResponse> =>
    api.get('admin/faq/topic', { params: { ...params, page: 1, per_page: 1000 } }),
});
